import * as Yup from 'yup';
import { Copy } from '../copy/Copy';

export const POST_VALIDATION_SCHEMA = Yup.object({
  content: Yup.string()
    .trim()
    .min(1, Copy.generate('Errors.minChar'))
    .max(500, Copy.generate('Errors.maxChar'))
    .required(Copy.generate('Errors.required')),
});
